import { TextField } from '@hulu/react-style-components';
import styled from 'styled-components';

export const StyledHuluTextField = styled(TextField)`
  &.without-number-arrows::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;
